module.exports = __webpack_public_path__ + "img/success.89bfd02a.svg";